import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'tank-notification-tooltip',
  templateUrl: './tank-notification-tooltip.component.html',
  styleUrls: ['./tank-notification-tooltip.component.css']
})
/** widget-alarm-details component*/
export class TankNotificationTooltipComponent implements OnInit {
  @Input() id: number;
  @Input() tankNotifications: [];
  constructor(
    public translate: TranslateService,
    private logger: LogService
  ) { }

  gridTitles: string [];

  ngOnInit(): void {
    // populate gridTitles from string resource
    this.gridTitles = [
      this.translate.instant("Dashboard.Severity"),
      this.translate.instant("Dashboard.Message"),
      this.translate.instant("Dashboard.Date")
    ]
    this.logger.trackEvent('TankGrid', 'rollover', 'TankNotificationCountRollover', this.id)
  }
}
